import { StandardEvents } from '@shopify/events';

class HotspotFeatureComponent extends HTMLElement {
  connectedCallback() {
    this.addEventListener(StandardEvents.cartLinesUpdate, this.handleCartUpdate);
  }

  disconnectedCallback() {
    this.removeEventListener(StandardEvents.cartLinesUpdate, this.handleCartUpdate);
  }

  handleCartUpdate = (event) => {
    const productForm = event.target instanceof Element ? event.target.closest('product-form-component') : null;
    if (!productForm || !productForm.closest('.hotspot-feature__content')) return;

    productForm.dataset.loading = 'true';
    event.promise?.finally(() => {
      delete productForm.dataset.loading;
    });
  };
}

if (!customElements.get('hotspot-feature-component')) {
  customElements.define('hotspot-feature-component', HotspotFeatureComponent);
}
